import { render, staticRenderFns } from "./businessClass.vue?vue&type=template&id=0039bb21&scoped=true"
import script from "./businessClass.vue?vue&type=script&lang=js"
export * from "./businessClass.vue?vue&type=script&lang=js"
import style0 from "./businessClass.vue?vue&type=style&index=0&id=0039bb21&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039bb21",
  null
  
)

export default component.exports